import { AssignmentsModel } from "./AssignmentsModel";
import {
  AssignmentDetailOutput,
  UpdateAssignmentRequestInput,
  AssignmentListResponseOutput,
  UpdateAcceptanceRequest,
  UpdateAcceptanceResponse,
  ProviderServicePointsSummaryOutput,
  ProviderServicePointsRequestInput,
  UpdateAdjustoIdRequest,
  UpdateAdjustoIdResponse,
  UpdateMissionStatusRequest,
  UpdateMissionStatusResponse,
} from "./Assignments.responses";

export class AssignmentsAdapter {
  private assignmentsModel: AssignmentsModel;

  constructor(assignmentsModel: AssignmentsModel) {
    this.assignmentsModel = assignmentsModel;
  }

  async updateAssignment(
    externalAssignmentId: string,
    updateData: UpdateAssignmentRequestInput,
    token: string,
  ): Promise<{ status: number; data: AssignmentDetailOutput | null }> {
    return await this.assignmentsModel.updateAssignment(externalAssignmentId, updateData, token);
  }

  async getAssignmentsByAcceptanceStatus(
    acceptanceStatus: string,
    missionStatus: string,
    token: string,
    page: number = 1,
    size: number = 10,
  ): Promise<{ status: number; data: AssignmentListResponseOutput | null }> {
    return await this.assignmentsModel.getAssignmentsByAcceptanceStatus(
      acceptanceStatus,
      missionStatus,
      token,
      page,
      size,
    );
  }

  async updateAcceptance(
    externalAssignmentId: string,
    updateAcceptanceData: UpdateAcceptanceRequest,
    token: string,
  ): Promise<{ status: number; data: UpdateAcceptanceResponse | null }> {
    return await this.assignmentsModel.updateAcceptance(
      externalAssignmentId,
      updateAcceptanceData,
      token,
    );
  }

  async searchAssignment(
    searchParams: {
      adjustoId?: string;
      externalId?: string;
      claimId?: string;
    },
    token: string,
  ): Promise<{ status: number; data: AssignmentDetailOutput | null }> {
    return await this.assignmentsModel.searchAssignment(searchParams, token);
  }

  async getServiceProviders(
    token: string,
  ): Promise<{ status: number; data: ProviderServicePointsSummaryOutput | null }> {
    return await this.assignmentsModel.getServiceProviders(token);
  }

  async updateProviderInformations(
    providerId: string,
    updateData: ProviderServicePointsRequestInput,
    token: string,
  ): Promise<{ status: number; data: ProviderServicePointsSummaryOutput | null }> {
    return await this.assignmentsModel.updateProviderInformations(providerId, updateData, token);
  }

  async getAssignment(
    externalAssignmentId: string,
    token: string,
  ): Promise<{ status: number; data: AssignmentDetailOutput | null }> {
    return await this.assignmentsModel.getAssignment(externalAssignmentId, token);
  }

  async updateAdjustoId(
    externalAssignmentId: string,
    updateData: UpdateAdjustoIdRequest,
    token: string,
  ): Promise<{ status: number; data: UpdateAdjustoIdResponse | null }> {
    return await this.assignmentsModel.updateAdjustoId(externalAssignmentId, updateData, token);
  }

  async updateMissionStatus(
    externalAssignmentId: string,
    updateData: UpdateMissionStatusRequest,
    token: string,
  ): Promise<{ status: number; data: UpdateMissionStatusResponse | null }> {
    return await this.assignmentsModel.updateMissionStatus(externalAssignmentId, updateData, token);
  }

  async exportAssignmentsByMonth(
    year: number,
    month: number,
    token: string,
  ): Promise<{ status: number; data: Blob | null }> {
    return await this.assignmentsModel.exportAssignmentsByMonth(year, month, token);
  }
}
